<template>
  <div class="detailed-core-set-layout">
    <div class="content">
      <img id="coreSetImg" :src="coreSetInfo.image" />
      <p id="nameP">{{ coreSetInfo.name }}</p>

      <v-btn id="moreInfoBtn" large>
        <v-icon id="moreInfoIcon">mdi-newspaper-variant-outline</v-icon>
        More Info
      </v-btn>

      <v-row id="tabRow">
        <v-col sm="6" class="left" :class="isDetailDesc ? 'active' : ''" @click="() => { isDetailDesc = true; }">
          <p id="descP">Description</p>
          <div id="arrowDiv" :style="[isDetailDesc ? {'display': 'inherit'} : {'display': 'none'}]"></div>
        </v-col>
        <v-col sm="6" class="right" :class="isDetailDesc ? '' : 'active'" @click="() => { isDetailDesc = false; }">
          <p id="attribP">Attributes</p>
          <div id="arrowDiv" :style="[isDetailDesc ? {'display': 'none'} : {'display': 'inherit'}]"></div>
        </v-col>
      </v-row>

      <v-row id="tabContent">
        <v-col sm="12">
          <div id="descDiv" :style="[isDetailDesc ? {'display': 'inherit'} : {'display': 'none'}]">
            <span>{{ coreSetInfo.desc }}</span>
          </div>
          <div id="attrDiv" :style="[isDetailDesc ? {'display': 'none'} : {'display': 'inherit'}]">
            <p v-for="(attr, index) in coreSetInfo.attrs" :key="index">
              <span>{{ attr.trait_type }}: </span>
              <span>{{ attr.value }}</span>
            </p>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MgCoreSetDetail',
    props: {
      coreSetInfo: Object,
    },
    data: () => ({
      isDetailDesc: true,
    }),
    mounted() {
    },
    methods: {
    },
    computed: {
    },
  }
</script>

<style scoped>
  .detailed-core-set-layout {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    border-top-left-radius: 255px 15px;
    border-top-right-radius: 15px 225px;
    border-bottom-right-radius: 225px 15px;
    border-bottom-left-radius: 15px 255px;
    border: solid #881d84 18px;
    box-shadow: 20px 38px 34px -26px #626262;
    -webkit-transition: all .5s ease;
    transition: all .5s ease;
    background: #881d84;
  }
  .detailed-core-set-layout p {
    margin: 0px;
    font-family: Architects Daughter;
  }
  .detailed-core-set-layout span {
    font-family: Architects Daughter;
  }

  .detailed-core-set-layout .content {
    padding: 10px;
    background-color: #131313;
    border-radius: 29px 29px 29px 29px;
  }

  #coreSetImg {
    width: 100%;
    border-top-left-radius: 29px;
    border-top-right-radius: 29px;
  }

  #nameP {
    width: 100%;
    font-weight: 400;
    font-size: 20px;
    color: #E1DD8F;
    text-align: center;
    margin-top: 20px;
  }

  #tabRow {
    margin-top: 20px;
    padding: 0px 10px;
  }
  #tabRow .left {
    cursor: pointer;
    position: relative;
  }
  #tabRow .left.active {
    background-color: white;
  }
  #tabRow .left #descP {
    color: #9B544C;
    text-align: center;
    font-weight: 700;
  }
  #tabRow .left #arrowDiv {
    width: 20px;
    height: 20px;
    border-width: 10px;
    border-style: solid;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-top-color: #e9e9e9;
    position: absolute;
    bottom: -20px;
    left: 50%;
  }
  #tabRow .right {
    cursor: pointer;
    position: relative;
  }
  #tabRow .right.active {
    background-color: white;
  }
  #tabRow .right #attribP {
    color: #9B544C;
    text-align: center;
    font-weight: 700;
  }
  #tabRow .right #arrowDiv {
    width: 20px;
    height: 20px;
    border-width: 10px;
    border-style: solid;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-top-color: #e9e9e9;
    position: absolute;
    bottom: -20px;
    left: 50%;
  }

  #tabContent {
    padding: 20px;
  }
  #tabContent #descDiv span {
    color: white;
    text-align: center;
    font-size: 14px;
  }
  #tabContent #attrDiv p {
    color: white;
    font-size: 14px;
  }

  #moreInfoBtn {
    background-color: #6EC1E4;
    margin-left: auto;
    margin-right: auto;
    text-transform: inherit;
    display: flex;
    margin-top: 20px;
    margin-bottom: 10px;
    font-family: Architects Daughter;
    font-size: 16px;
  }
  #moreInfoBtn #moreInfoIcon {
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyGurus/MgCoreSetDetail.vue